/**
 * Explore Unknown diplomatic accord picklist (levels 5 and 7).
 * Must stay in sync with config/exploreUnknownDiplomaticAccordPicklist.js
 */
export const DIPLOMATIC_ACCORD_PICKLIST = Object.freeze([
  Object.freeze({
    optionIndex: 0,
    variant: 'strategicCoordination',
    profileKey: 'strategic_coordination',
    bonusId: 'diplomatic_accords_strategic_coordination_l5',
    bonusName: 'Diplomatic Accords - Strategic Coordination',
    icon: '/images/strategic_coordination.jpg',
    i18nKey: 'levelBonus5',
  }),
  Object.freeze({
    optionIndex: 1,
    variant: 'publicRelations',
    profileKey: 'public_relations',
    bonusId: 'diplomatic_accords_public_relations_l5',
    bonusName: 'Diplomatic Accords - Public Relations',
    icon: '/images/public_relations.jpg',
    i18nKey: 'levelBonus6',
  }),
  Object.freeze({
    optionIndex: 2,
    variant: 'commandDirective',
    profileKey: 'command_directive',
    bonusId: 'diplomatic_accords_command_directive_l5',
    bonusName: 'Diplomatic Accords - Command Directive',
    icon: '/images/command_directive.jpg',
    i18nKey: 'levelBonus7',
  }),
]);

export const REACTIVE_DOCTRINE_LEVEL = 6;
export const SECOND_DIPLOMATIC_ACCORD_LEVEL = 7;

export function getDiplomaticAccordPicklistOption(optionIndex) {
  const idx = Number(optionIndex);
  if (!Number.isInteger(idx) || idx < 0 || idx >= DIPLOMATIC_ACCORD_PICKLIST.length) {
    return null;
  }
  return DIPLOMATIC_ACCORD_PICKLIST[idx];
}

export function getSecondDiplomaticAccordPicklistOptions(firstOptionIndex) {
  const firstIdx = Number(firstOptionIndex);
  if (!Number.isInteger(firstIdx) || firstIdx < 0 || firstIdx >= DIPLOMATIC_ACCORD_PICKLIST.length) {
    return DIPLOMATIC_ACCORD_PICKLIST.slice(0, 2);
  }
  return DIPLOMATIC_ACCORD_PICKLIST.filter((opt) => opt.optionIndex !== firstIdx);
}
